import React from 'react';

const educationInfo =  [
    {
    "id": 1,
    "toggle": "What is LifeLong365?",
    "expose": 'We believe that "Right information in perfect time is more precious than the most expensive goods in the world." a theme of this LifeLong365  that  offers a wide variety of information from schools to corporate world.',
    "expose1": "Today's world is a world of information and it plays a vital role in success. It connects people of all ages by providing the latest certificate exam, career essential hacks, and educational institution information.",
    },
    {
    "id": 2,
    "toggle": "How much does LifeLong365 cost?",
    "expose": "LifeLong365 has developed to create a skillful generation. No cost, no contracts.",
    },
    {
    "id": 3,
    "toggle": "What is the difference between LifeLong365 with other apps?",
    "expose": "LifeLong365 is a platform where you get school info to career hacks. All kinds of information under same the roof. Its vision is to create a competent generation for the modern era. Students would get exam info, must needed skill info which will make easy their life and would be skillful which isn't available in other apps.",
    },
    {
    "id": 4,
    "toggle": "What can I do?",
    "expose": "[School - University(BD Based)]: The insufficiency of the the right information sometime makes us helpless and the lack English proficiency in rural areas makes is more difficult. Students from school to University would get necessary info and wouldn't miss any exam deadline, preparation ... ... .",
    "expose1":'[Certificate and Career(JP Based)]: Job preparation, Skill up, Living hacks, and other necessary info are found in this app. Just click and search for what information you want to know.'
    },
    {
    "id": 5,
    "toggle": "How can I improve my skills using LifeLong365?",
    "expose": "LifeLong365 has an extensive section based on what you need. From academic to Certification then certification to corporate career suggestions, and whatnot.",
    },
    {
    "id": 6,
    "toggle": "Is LifeLong365 good for school going students?",
    "expose": "The LifeLong365 is developed with a view to provide information to school going kids to make their academic journey easier and make them competent to upcoming future.",
    "expose1": "When A kid gets information related to college, university, and career, it makes their mind broader and mentally take preparation for those challenges and also impacts their outlook and confidence."
    },
  
]
function CollapseSection() {

  return (
    <>
   
    <div className='collapseDiv'>

        <h1 className="collapseText text-5xl pt-24 pb-24 font-bold">Frequently asked questions</h1>
    
          {educationInfo.map((content) => (
          <div className='collapseBox'>
            <div className="collapse collapse-plus border border-base-300 bg-base-100">
              <input type="checkbox"/> 

              <div style={{fontFamily:'raleway'}} className="textLeft collapse-title text-sm lg:text-xl">
                {content.toggle}
              </div>
              
              <div className="textLeft collapse-content text-sm lg:text-xl"> 
                  <p style={{fontFamily:'raleway'}}>{content.expose}</p>
                  {content?.expose1 && <p style={{fontFamily:'raleway'}} className="pt-6">{content.expose1}</p>}
              </div>
              </div>
          </div>
          ))}
    </div>
   
     </>


  )
}

export default CollapseSection